module.exports = __webpack_public_path__ + "assets/img/LTC034.e8cddf83.png";